var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHamburger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 18,
    viewBox: "0 0 26 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 35"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 23 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.75 9C0.75 8.4201 1.2201 7.95 1.8 7.95L24.2 7.94999C24.7799 7.94999 25.25 8.4201 25.25 8.99999C25.25 9.57989 24.7799 10.05 24.2 10.05L1.8 10.05C1.2201 10.05 0.75 9.57989 0.75 9Z",
    fill: "#8D9299"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 24 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.75 2C0.75 1.4201 1.2201 0.949997 1.8 0.949997L24.2 0.949996C24.7799 0.949996 25.25 1.4201 25.25 2C25.25 2.57989 24.7799 3.05 24.2 3.05L1.8 3.05C1.2201 3.05 0.75 2.5799 0.75 2Z",
    fill: "#8D9299"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 25 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.75 16C0.75 15.4201 1.2201 14.95 1.8 14.95L24.2 14.95C24.7799 14.95 25.25 15.4201 25.25 16C25.25 16.5799 24.7799 17.05 24.2 17.05L1.8 17.05C1.2201 17.05 0.75 16.5799 0.75 16Z",
    fill: "#8D9299"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.e31ec3d05710622f692b3d30aa75bfa6.svg";
export { ForwardRef as ReactComponent };